{
  "name": "@invertase/firebaseui-core",
  "version": "0.0.8",
  "description": "Core authentication service for Firebase UI",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./brands/*": "./brands/*"
  },
  "files": [
    "dist",
    "brands"
  ],
  "scripts": {
    "prepare": "pnpm run build",
    "emulators:start": "firebase emulators:start -P demo-firebaseui",
    "build": "tsup",
    "build:local": "pnpm run build && pnpm pack",
    "dev": "tsup --watch",
    "lint": "eslint . --ext .ts",
    "lint:fix": "eslint . --ext .ts --fix",
    "format": "prettier --write \"src/**/*.ts\" \"tests/**/*.ts\"",
    "format:check": "prettier --check \"src/**/*.ts\" \"tests/**/*.ts\"",
    "clean": "rimraf dist",
    "test:unit": "vitest run src",
    "test:unit:watch": "vitest tests",
    "test:integration": "vitest run tests",
    "test:integration:watch": "vitest integration",
    "test": "vitest run",
    "version:bump": "pnpm version patch",
    "publish:tags": "sh -c 'TAG=\"${npm_package_name}@${npm_package_version}\"; git tag --list \"$TAG\" | grep . || git tag \"$TAG\"; git push origin \"$TAG\"'",
    "release": "pnpm run build && pnpm pack --pack-destination --pack-destination ../../releases/"
  },
  "keywords": [
    "firebase",
    "auth",
    "authentication",
    "firebaseui"
  ],
  "author": "TODO",
  "license": "MIT",
  "peerDependencies": {
    "firebase": "catalog:peerDependencies"
  },
  "dependencies": {
    "@invertase/firebaseui-translations": "workspace:*",
    "libphonenumber-js": "^1.12.23",
    "nanostores": "catalog:",
    "qrcode-generator": "^2.0.4",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@types/google-one-tap": "^1.2.6",
    "@types/jsdom": "catalog:",
    "firebase": "catalog:",
    "jsdom": "catalog:",
    "rimraf": "catalog:",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vitest": "catalog:"
  }
}
